import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  type: 'privacy' | 'terms';
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  type
}: PolicyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-414">
      <div className="absolute inset-0 bg-dark/60 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-415" />

      <div className="relative bg-cream w-full max-w-3xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-[fadeIn_0.3s_ease-out]" data-id="element-416">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-forest/10 bg-white" data-id="element-417">
          <h2 className="font-serif text-xl md:text-2xl font-bold text-forest" data-id="element-418">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-cream-dark transition-colors text-dark/60 hover:text-dark" aria-label="Cerrar" data-id="element-419">
            <X size={24} data-id="element-420" />
          </button>
        </div>

        <div className="p-6 md:p-8 overflow-y-auto text-sm md:text-base text-dark/80 space-y-6" data-id="element-421">
          {type === 'privacy' ? <>
              <p data-id="element-422">Última actualización: {new Date().toLocaleDateString()}</p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-423">
                1. Información que recopilamos
              </h3>
              <p data-id="element-424">
                Recopilamos información que usted nos proporciona directamente
                cuando realiza una compra, se suscribe a nuestro boletín o se
                comunica con nosotros. Esta información puede incluir su nombre,
                dirección de correo electrónico e información de pago (procesada
                de forma segura a través de nuestros proveedores de pago de
                terceros).
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-425">
                2. Uso de la información
              </h3>
              <p data-id="element-426">
                Utilizamos la información que recopilamos para procesar sus
                transacciones, enviarle el producto digital adquirido,
                proporcionarle servicio al cliente y enviarle comunicaciones de
                marketing (si ha optado por recibirlas).
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-427">
                3. Cookies y tecnologías de seguimiento
              </h3>
              <p data-id="element-428">
                Utilizamos cookies y tecnologías similares (como el Píxel de
                Meta/Facebook) para analizar el tráfico del sitio web,
                personalizar el contenido y publicar anuncios dirigidos. Puede
                configurar su navegador para que rechace todas las cookies o
                para que le indique cuándo se envía una cookie.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-429">
                4. Compartir información
              </h3>
              <p data-id="element-430">
                No vendemos, comercializamos ni transferimos de otro modo a
                terceros su información de identificación personal. Esto no
                incluye a los terceros de confianza que nos asisten en la
                operación de nuestro sitio web, la realización de nuestro
                negocio o el servicio a usted, siempre que dichas partes
                acuerden mantener esta información confidencial.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-431">
                5. Sus derechos
              </h3>
              <p data-id="element-432">
                Usted tiene derecho a acceder, corregir o eliminar su
                información personal. Si desea ejercer estos derechos,
                comuníquese con nuestro equipo de soporte.
              </p>
            </> : <>
              <p data-id="element-433">Última actualización: {new Date().toLocaleDateString()}</p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-434">
                1. Aceptación de los términos
              </h3>
              <p data-id="element-435">
                Al acceder y utilizar este sitio web, usted acepta estar sujeto
                a estos Términos y Condiciones. Si no está de acuerdo con alguna
                parte de estos términos, no podrá acceder al servicio.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-436">
                2. Producto Digital
              </h3>
              <p data-id="element-437">
                El producto ofrecido es estrictamente digital (formato PDF y/o
                video). No se enviará ningún producto físico a su dirección. El
                acceso al producto se proporcionará inmediatamente después de la
                confirmación del pago.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-438">
                3. Política de Reembolso y Garantía
              </h3>
              <p data-id="element-439">
                Ofrecemos una garantía de devolución de dinero de 30 días. Si no
                está satisfecho con el producto, puede solicitar un reembolso
                completo dentro de los 30 días posteriores a la compra. El
                reembolso se procesará a través del mismo método de pago
                utilizado para la compra.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-440">
                4. Propiedad Intelectual
              </h3>
              <p data-id="element-441">
                Todo el contenido incluido en el producto digital, como textos,
                gráficos, logotipos, imágenes y compilaciones de datos, es
                propiedad de la empresa y está protegido por las leyes de
                derechos de autor. No se permite la reproducción, distribución o
                reventa del material sin consentimiento expreso.
              </p>

              <h3 className="font-bold text-dark text-lg mt-6 mb-2" data-id="element-442">
                5. Descargo de Responsabilidad Médica
              </h3>
              <p data-id="element-443">
                La información proporcionada en este producto tiene fines
                educativos e informativos únicamente y no sustituye el consejo,
                diagnóstico o tratamiento médico profesional. Siempre busque el
                consejo de su médico u otro proveedor de salud calificado con
                cualquier pregunta que pueda tener con respecto a una condición
                médica.
              </p>
            </>}
        </div>

        <div className="p-4 border-t border-forest/10 bg-white flex justify-end" data-id="element-444">
          <button onClick={onClose} className="px-6 py-2 bg-forest text-white rounded-lg font-medium hover:bg-forest-light transition-colors" data-id="element-445">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}